export function toggleBookingWidget() {
    
    $(".show-widget").on("click", function(evt) {
        evt.preventDefault();
        $("#Tock_widget_container .TockButton-link").trigger( "click");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/toggle-booking-widget.js